import { render, staticRenderFns } from "./CreateTagModal.vue?vue&type=template&id=06dca2d8&scoped=true&"
import script from "./CreateTagModal.vue?vue&type=script&lang=js&"
export * from "./CreateTagModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTagModal.vue?vue&type=style&index=0&id=06dca2d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dca2d8",
  null
  
)

export default component.exports